import { Box, Button } from "@chakra-ui/react";
import { FeeFormSectionCalculationItem } from "features/fees/form/FeeFormSectionCalculationItem";
import { FeeCreateAPIDataRequest } from "gen/model/feeCreateAPIDataRequest";
import { NamedDateData } from "gen/model/namedDateData";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import React from "react";
import { Control, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Restricted } from "shared/components/access/Restricted";
import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockHeader,
  ContentBlockTitle,
} from "shared/components/content/ContentBlock";

interface FeeCalculationFormSectionProps {
  control: Control<
    FeeCreateAPIDataRequest & {
      fee_eligible_for_true_up: boolean;
    }
  >;
  namedDateData: NamedDateData[];
}

const FeeFormSectionCalculation: React.FC<FeeCalculationFormSectionProps> = ({
  control,
  namedDateData,
}) => {
  const { t } = useTranslation(["fees"]);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "fee_calculations",
  });

  return (
    <ContentBlock>
      <ContentBlockHeader>
        <ContentBlockTitle>{t("fees:feeCalculations.title")}</ContentBlockTitle>
      </ContentBlockHeader>
      <ContentBlockBody>
        <Box>
          {fields.map((field, index) => (
            <FeeFormSectionCalculationItem
              key={field.id}
              index={index}
              isLast={index === fields.length - 1}
              namedDates={namedDateData}
              onRemove={() => {
                remove(index);
              }}
            />
          ))}
        </Box>
        <Restricted permission={PermissionTypeEnum.config}>
          <Box py={4}>
            <Button
              colorScheme="secondary"
              size="sm"
              onClick={() =>
                append({
                  fee_parts: [
                    {
                      fee_basis_id: "",
                      fee_rate: "",
                    },
                  ],
                })
              }
            >
              {t("fees:feeCalculations.addAnother")}
            </Button>
          </Box>
        </Restricted>
      </ContentBlockBody>
    </ContentBlock>
  );
};

export default FeeFormSectionCalculation;
